// @formatter:off
// throttle/debounce => $.debounce(ms, function() {})), $.throttle(ms, function() {}))
!function(t,d){var e,n=t.jQuery||t.cph||(t.cph={});n.throttle=e=function(i,o,c,r){var a,f=0;function t(){var t=this,n=new Date-f,u=arguments;function e(){f=+new Date,c.apply(t,u)}r&&!a&&e(),a&&clearTimeout(a),r===d&&i<n?e():!0!==o&&(a=setTimeout(r?function(){a=d}:e,r===d?i-n:i))}return"boolean"!=typeof o&&(r=c,c=o,o=d),n.guid&&(t.guid=c.guid=c.guid||n.guid++),t},n.debounce=function(t,n,u){return u===d?e(t,n,!1):e(t,u,!1!==n)}}(this);

// cookie => $.cookie.set(name, value, days), $.cookie.get(name), $.cookie.delete(name)
!function(e,r){(e.jQuery||e.cph||(e.cph={})).cookie={set:function(e,t,n,o){var i;if(n){var c=new Date;c.setTime(c.getTime()+24*n*60*60*1e3),i=";expires="+c.toUTCString()}else i="";r.cookie=e+"="+t+i+";path=/"},get:function(e){var t=r.cookie.match(RegExp("(?:^|;\\s*)"+e.replace(/([.*+?\^${}()|\[\]\/\\])/g,"\\$1")+"=([^;]*)"));return t?t[1]:null},delete:function(e){document.cookie=e+"=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";document.cookie=e+"=;domain=."+window.location.hostname+";expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/"},enabled:function(e){try{document.cookie = 'cookietest=1';var ret=document.cookie.indexOf('cookietest=')!==-1;document.cookie='cookietest=1;expires=Thu, 01-Jan-1970 00:00:01 GMT';return ret;}catch(e){return false;}}}}(window,document);
// @formatter:on

/*jQuery(function($) {
	var logError = function(type, error) {
		console.error(error);
	};

	window.onerror = function(message, url, line, column, error) {
		logError('window', {message: message, url: url, line: line, column: column, error: error});
		return true;
	};

	var userAborted = function(jqXHR) {
		return !jqXHR.getAllResponseHeaders();
	};

	$.ajaxSetup({
		error: function(jqXHR, textStatus, errorThrown) {
			if(!userAborted(jqXHR)) {
				if(jqXHR.status === 0) {
					cph.topResponse('alert', 'Unable to connect to network. Please try again.', 5000); // _responses.js
				} else if(jqXHR.status === 404) {
					cph.topResponse('alert', 'The requested page was not found [404]', 5000); // _responses.js
				} else if(jqXHR.status === 500) {
					cph.topResponse('alert', 'Internal server error [500]', 5000); // _responses.js
				}
				cph.hideTopLoaderBar(); // _loaders.js
				logError('ajax', {message: errorThrown, status: textStatus});
			}
		}
	});
});*/

function domReadyInit() {
    cph.initFixedHeader(); // _init.js
    cph.initPushMenuToggle();  // _init.js
    cph.initSubMenu(); // _init.js
    cph.initPhpTopResponses(); // _responses.js
}

function checkDomInit() {
    cph.initStickyPanel(); // _init.js
    cph.initCookieBlocks(); // _init.js
    cph.initTooltips(); // _init.js
    cph.initSlimImage(); // _init.js
    cph.initTabs(); // _init.js
    cph.initMasks(); // _init.js
    cph.initAutoSize(); // _init.js
    cph.initSelectize(); // _init.js
    cph.initTableSorter(); // _init.js
    cph.initSortable(); // _init.js
    cph.initTinyMCE(); // _init.js
    cph.initDateRangePicker(); // _init.js
    cph.initKeyStops(); // _init.js
    cph.initMaxLength(); // _init.js
}

function resizeDomInit() {
    cph.initFixedHeader(); // _init.js
    cph.initPushMenuToggle();  // _init.js
    cph.initSubMenu(); // _init.js
}

// ANY FUNCTIONS WHICH NEED TO BE CALLED ON DOM READY
jQuery(function() {
    domReadyInit();
    checkDomInit();
});

// ANY FUNCTIONS WHICH NEED TO BE CALLED ON RESIZE BUT CAN WAIT UNTIL FINISHED
jQuery(window).resize(jQuery.debounce(250, function() {
    resizeDomInit();
}));




var cph = cph || {};
(function($) {
    var body = $(document.body),
        pageWrap = $('#page-wrap'),
        header = $('#header');

    cph.freezeBody = function() {
        if(!body.data('freezeBody-style')) {
            body.data('freezeBody-style', body.attr('style'));
        }
        body.css({overflow: 'hidden', minWidth: 0, width: body.innerWidth() + 'px'});
    };

    cph.unfreezeBody = function() {
        var style = body.data('freezeBody-style');
        body.data('freezeBody-style', '');
        if(style) body.attr('style', style);
        else body.removeAttr('style');
    };

    cph.isInLitbox = function(el) {
        if(cph.litboxIsLoaded()) {
            return Litbox.get(el).length;
        }
        return false;
    };

    cph.isInViewport = function(el, partially) {
        if(!partially) partially = false;

        if(typeof jQuery === 'function' && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();
        var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        var windowWidth = (window.innerWidth || document.documentElement.clientWidth);

        if(partially) {
            var vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
            var horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);
            return (vertInView && horInView);
        } else {
            return ((rect.left >= 0) && (rect.top >= 0) && ((rect.left + rect.width) <= windowWidth) && ((rect.top + rect.height) <= windowHeight));
        }
    };

    cph.popupWindow = function(url, width, height) {
        var left = (screen.width / 2) - (width / 2),
            top = (screen.height / 2) - (height / 2);

        window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);
    };

    cph.tabWithin = function(withinEl, selectors) {
        if(!selectors) selectors = 'input:not([type="hidden"]), select, textarea, button, a, [data-html-editor], [tabindex]:not([tabindex^="-"])';

        var tabbable = withinEl.find(selectors).filter(':visible'),
            firstTab = tabbable.first(),
            lastTab = tabbable.last();

        $(document.activeElement).blur();

        firstTab.add(lastTab).off('keydown');

        firstTab.focus();

        lastTab.on('keydown', function(e) {
            if(((e.which === 9 || e.key === 'Tab') && !e.shiftKey)) {
                e.preventDefault();
                firstTab.focus();
            }
        });

        firstTab.on('keydown', function(e) {
            if(((e.which === 9 || e.key === 'Tab') && e.shiftKey)) {
                e.preventDefault();
                lastTab.focus();
            }
        });
    };

    cph.doNotAllowTabbing = function(within, selectors) {
        if(!selectors) selectors = 'input:not([type="hidden"]), select, textarea, button, a, [data-html-editor], [tabindex]:not([tabindex^="-"])';

        const allTabbable = $(selectors).filter(':visible');

        $(within).each(function() {
            const notTabbable = $(this).find(allTabbable);
            const firstIndex = allTabbable.index(notTabbable.first());
            const lastIndex = allTabbable.index(notTabbable.last());

            notTabbable.on('keyup', function(e) {
                if(e.key === 'Tab' || e.which === 9) {
                    e.preventDefault();
                    $(document.activeElement).blur();

                    let tabTo = [];
                    if(e.shiftKey) {
                        tabTo = allTabbable.filter(function(i, el) {
                            return i < firstIndex && !$(el).is(notTabbable);
                        }).last();

                        if(!tabTo.length)
                            tabTo = allTabbable.last();
                    } else {
                        tabTo = allTabbable.filter(function(i, el) {
                            return i > lastIndex && !$(el).is(notTabbable);
                        }).first();

                        if(!tabTo.length)
                            tabTo = allTabbable.last();
                    }
                    if(tabTo.length) tabTo.focus();
                }
            });
        });
    };

    cph.toggleFixedHeader = function() {
        if(body.hasClass('fixed-header')) {
            body.removeClass('fixed-header');
            pageWrap.css({paddingTop: '0'});
        } else {
            body.addClass('fixed-header');
            pageWrap.css({paddingTop: header.outerHeight()});
        }
    };

    cph.getFixedHeaderHeight = function() {
        if(header.length) {
            if(header.css('position') === 'fixed') {
                return header.outerHeight();
            }
        }
        return 0;
    };

    cph.getAdjustedTopOffset = function(element) {
        if(element.length) {
            return element.offset().top - cph.getFixedHeaderHeight();
        }
        return 0;
    };

    cph.whichTransitionEndEvent = function() {
        var t, el = document.createElement('fakeelement');

        var transitions = {
            'transition'      : 'transitionend',
            'OTransition'     : 'oTransitionEnd',
            'MozTransition'   : 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        };

        for(t in transitions) {
            if(el.style[t] !== undefined) {
                return transitions[t];
            }
        }
    };

    cph.whichAnimationEndEvent = function() {
        var a, el = document.createElement('fakeelement');

        var animations = {
            'animation'      : 'animationend',
            'OAnimation'     : 'oAnimationEnd',
            'MozAnimation'   : 'animationend',
            'WebkitAnimation': 'webkitAnimationEnd'
        };

        for(a in animations) {
            if(el.style[a] !== undefined) {
                return animations[a];
            }
        }
    };

    cph.getTemplate = function(tplId, vars) {
        tplId = '#' + tplId.replace(/^#/, '');

        var tpl = $(tplId);
        if(tpl.length) {
            return tpl.clone().html().replace(/(\{\{([^\}]*)\}\})/g, function(match, braced, variable) {
                var methods = variable.split('.'),
                    methodName = $.extend(true, {}, vars),
                    value;

                for(var i in methods) methodName = methodName[methods[i]];
                if(typeof methodName !== 'undefined')
                    value = methodName;

                if(!value) {
                    var functionName = window;
                    for(var i in methods) functionName = functionName[methods[i]];
                    if(typeof functionName !== 'undefined')
                        value = functionName;
                }

                return match.replace(braced, value);
            });
        }

        return false;
    };

    cph.callbackCaller = function(callback, data) {
        if($.type(callback) === 'function') {
            //callback.call(this, [data]);
            callback.call(this, data);
        } else if($.type(callback) === 'string') {
            var callbacks = callback.split(/[,|;]/); // will split on comma, pipe or semicolon
            $.each(callbacks, function(i, v) {
                if($.isFunction(window[v])) {
                    window[v](data);
                } else if($.isFunction(window.cph[v])) {
                    window.cph[v](data);
                }
            });
        }
    };

    cph.buildHiddenForm = function(method, action, data) {
        var form = $('<form/>', {
            method: method,
            action: action,
            class : 'ajax-submit'
        });
        if(data) {
            $.each(data, function(name, value) {
                $('<input/>', {
                    type : 'hidden',
                    name : name,
                    value: value
                }).prependTo(form);
            });
        }
        form.css({
            visibility: 'hidden',
            position  : 'absolute',
            left      : '-10000em',
            height    : '1px',
            width     : '1px',
            overflow  : 'hidden'
        });
        return form;
    };

    cph.replaceHtml = function(selector, html) {
        html = $(html);

        let el = $(selector);
        if(!el.length) return;

        let innerHtml = html.find(selector);
        if(innerHtml.length) {
            $(selector).html(innerHtml.html());
            return;
        }

        if(html.is(selector)) {
            $(selector).html(html.html());
            return;
        }

        $(selector).html(html);
    };

    cph.processAjaxSubmit = function(form, useLoader, useResponse) {
        var loader = $(form.data('use-loader')),
            response = $(form.data('use-response')),
            persistLoader = form.data('persist-loader');

        if(useLoader) {
            useLoader = $(useLoader);
            if(useLoader.length)
                loader = useLoader;
        }

        if(useResponse) {
            useResponse = $(useResponse);
            if(useResponse.length)
                response = useResponse;
        }

        if(form.hasClass('submitting'))
            return false;

        form.addClass('submitting');

        form.find('.error').removeClass('error');

        var findElement = function(selector, parent, lastCheck) {
            if(parent.find(selector).length)
                return parent.find(selector).first();

            if(parent.is('body'))
                return findElement(selector, parent.offsetParent(), true);

            if(lastCheck) return false;

            return findElement(selector, parent.offsetParent());
        };

        if(!loader.length)
            loader = findElement('.loader-bar, .pulse-loader, .progress-bar', form);

        if(!response.length)
            response = findElement('.response, .text-response', form);

        cph.hideAllResponses(response);
        cph.hideAllLoaderBars(loader);
        cph.hideAllPulseLoaders(loader);

        var updateTableSorter = function(el) {
            if(el.length) {
                var tsTable = el.is('.tablesorter') ? el : el.closest('.tablesorter');
                if(tsTable.length) tsTable.trigger('updateAll', [false]);
            }
        };

        var closeLightbox = function(el) {
            if(cph.litboxIsLoaded()) Litbox.hide(el);
        };

        var doOnAjaxComplete = function() {
            form.removeClass('submitting');

            if(!persistLoader && loader.length) {
                if(loader.is('.progress-bar')) {
                    cph.hideProgressBar(loader);
                    form.off('updateProgress');
                } else if(loader.is('.pulse-loader')) {
                    cph.hidePulseLoader(loader);
                } else {
                    cph.hideLoaderBar(loader);
                }
            } else {
                cph.hideTopLoaderBar();
            }

            checkDomInit();
        };

        $.ajax({
            url       : form.attr('action'),
            type      : form.attr('method'),
            dataType  : 'json',
            data      : form.serialize(),
            beforeSend: function() {
                if(loader.length) {
                    if(loader.is('.progress-bar')) {
                        cph.showProgressBar(loader);
                        form.on('updateProgress', function(e, pctComplete, text) {
                            cph.updateProgressBar(loader, pctComplete, text);
                        });
                    } else if(loader.is('.pulse-loader')) {
                        cph.showPulseLoader(loader);
                    } else {
                        cph.showLoaderBar(loader);
                    }
                } else {
                    cph.showTopLoaderBar();
                }
                if(response.length) {
                    cph.fadeResponse(response);
                }

                var beforeSendCallback = form.data('before-send');
                setTimeout(function() {
                    cph.callbackCaller(beforeSendCallback);
                }, 0);
            }
        }).done(function(data) {
            if(typeof data.useTopResponse !== 'undefined') {
                cph.topResponse(data.type, data.message, data.useTopResponse);
            } else if(typeof data.showAlertBox !== 'undefined') {
                cph.loadLitbox(function() {
                    $.litAlert(data.message, null, {titleClass: 'alert', button: {class: 'alert'}});
                });
            } else if(response.length) {
                cph.showResponse(response, data.type, data.message, data.close, function() {
                    if(cph.tippedIsLoaded()) {
                        var tippedElement = $(Tipped.findElement(form[0]));
                        if(tippedElement.length) {
                            Tipped.refresh(tippedElement);
                        }
                    }
                });
            }

            if(!data.status) {
                if(typeof data.errorKeys !== 'undefined' && $.isArray(data.errorKeys)) {
                    $.each(data.errorKeys, function(i, errorKey) {
                        $('[name="' + errorKey + '"]').parent().addClass('error');
                    });
                }
            } else {
                if(typeof data.reset !== 'undefined') {
                    if(data.reset === 'all') {
                        form.trigger('reset');
                    } else {
                        if(!$.isArray(data.reset)) data.reset = data.reset.split(',');
                        $.each(data.reset, function(i, v) {
                            form.find('[name=' + $.trim(v) + ']').val(function() {
                                return this.defaultValue;
                            });
                        });
                    }
                    if(!response.hasClass('success')) {
                        if(response.length) {
                            cph.hideResponse(response);
                        }
                    }
                }

                if(typeof data.replaceHtml == 'object') {
                    cph.replaceHtml(data.replaceHtml.selector, data.replaceHtml.html);
                }

                if(typeof data.replaceUrl !== 'undefined') {
                    history.replaceState({}, null, data.replaceUrl);
                }

                if(typeof data.pushUrl !== 'undefined') {
                    history.pushState({}, null, data.pushUrl);
                }

                if(typeof data.clearSelectors !== 'undefined') {
                    form.find(data.clearSelectors).val('');

                    if(!response.hasClass('success')) {
                        if(response.length) {
                            cph.hideResponse(response);
                        }
                    }
                }

                var successCallback = form.data('success-callback');
                setTimeout(function() {
                    cph.callbackCaller(successCallback, data);
                }, 15);

                if(typeof data.callables !== 'undefined' && data.callables.length) {
                    $.each(data.callables, function(i, f) {
                        if($.isFunction(window[f.name])) {
                            window[f.name].apply(null, JSON.parse(f.params));
                        }
                    });
                }

                if(typeof data.closeLightbox !== 'undefined') {
                    var closeDelay = 0;
                    if(typeof data.closeLightbox === 'string')
                        closeDelay = parseInt(data.closeLightbox);
                    if(typeof data.closeLightbox === 'number')
                        closeDelay = data.closeLightbox;

                    setTimeout(function() {
                        closeLightbox(form);
                    }, closeDelay);
                }

                if(typeof data.removeElement !== 'undefined') {
                    var remove = $(data.removeElement),
                        table = remove.closest('table');
                    if(remove.length) {
                        if(data.message !== 'undefined' && !data.message)
                            if(response.length) {
                                cph.hideResponse(response);
                            }
                        remove.fadeOut(600, function() {
                            remove.remove();
                            updateTableSorter(table);
                        });

                        doOnAjaxComplete();
                        return;
                    }
                }

                if(typeof data.html !== 'undefined') {
                    var hel = $(data.html)[0],
                        bgColor, toReplace, appendTo, prependTo, id, parent;

                    if(typeof data.appendTo !== 'undefined') {
                        parent = $(data.appendTo);
                        if(parent.length) {
                            appendTo = parent;
                        }
                    } else if(typeof data.prependTo !== 'undefined') {
                        parent = $(data.prependTo);
                        if(parent.length) {
                            prependTo = parent;
                        }
                    }

                    if(appendTo) {
                        toReplace = $(data.html);
                        appendTo.append(toReplace);

                        if(!$.inViewport(toReplace, -50)) {
                            toReplace[0].scrollIntoView(false);
                        }
                    } else if(prependTo) {
                        toReplace = $(data.html);
                        prependTo.prepend(toReplace);

                        if(!$.inViewport(toReplace, -50)) {
                            toReplace[0].scrollIntoView(false);
                        }
                    } else {
                        id = $(hel).attr('id');
                        toReplace = $('#' + id);

                        if(toReplace.length) {
                            toReplace.html($(data.html).html());
                        }
                    }

                    if(toReplace.length) {
                        if(data.message !== 'undefined' && !data.message) {
                            if(response.length) {
                                cph.hideResponse(response);
                            }
                        }

                        updateTableSorter(toReplace);

                        if(typeof data.bgFadeColor !== 'undefined' && typeof data.bgFadeTime !== 'undefined') {
                            bgColor = toReplace.css('background-color');
                            toReplace.css({backgroundColor: data.bgFadeColor});
                            setTimeout(function() {
                                toReplace.css({
                                    backgroundColor: bgColor,
                                    transition     : 'background-color 1250ms linear'
                                });
                            }, data.bgFadeTime);
                            setTimeout(function() {
                                toReplace.css({transition: 'background-color 0s'});
                            }, data.bgFadeTime + 1250);
                        }

                        doOnAjaxComplete();
                        return;
                    }
                }

                if(typeof data.reload !== 'undefined') {
                    setTimeout(function() {
                        document.location.reload();
                    }, data.reload);
                    return;
                } else if(typeof data.redirect !== 'undefined') {
                    var delay = (typeof data.redirectDelay !== 'undefined') ? data.redirectDelay : 0;
                    setTimeout(function() {
                        window.location.href = data.redirect;
                    }, delay);
                    return;
                }
            }

            doOnAjaxComplete();
        }).always(function() {
            cph.callbackCaller(form.data('always-callback'));
        }).fail(function() {
            cph.callbackCaller(form.data('fail-callback'));
            doOnAjaxComplete();
        });
    };

    cph.tippedIsLoaded = function() {
        return typeof Tipped !== 'undefined';
    };

    cph.litboxIsLoaded = function() {
        return typeof Litbox !== 'undefined';
    };

})(jQuery);
$(document).on('click', '.action-menu__parent--expandable > a', function(e) {
    e.preventDefault();
    var clicked = $(this),
        parent = clicked.closest('.action-menu__parent'),
        menu = parent.find('ul');

    if(!parent.is('.expanded')) {
        parent.addClass('expanded');

        var random = Math.floor(Math.random() * 1000);
        $(document).one('close.actionMenu' + random, function() {
            $(document).off('.actionMenu' + random);
            parent.removeClass('expanded').addClass('closing');
            var animationEndEvent = cph.whichAnimationEndEvent();
            if(animationEndEvent) {
                parent.one(animationEndEvent, function() {
                    parent.removeClass('closing');
                });
            } else {
                parent.removeClass('closing');
            }
        });

        $(document).on('click.actionMenu' + random, function(e) {
            if($(e.target).closest(menu).length)
                return;
            $(document).trigger('close.actionMenu' + random);
        });
    }
});

$(document).on('click', '.admin-header__help-toggle', function() {
    var clicked = $(this),
        header = clicked.closest('.admin-header'),
        help = header.find('.admin-header__help').first();

    if(help.hasClass('expanded')) {
        clicked.removeClass('expanded');

        help.slideUp(90, function() {
            help.removeClass('expanded');
        });
    } else {
        clicked.addClass('expanded');

        help.slideDown(180, function() {
            help.addClass('expanded');
        });
    }
});

$(document).on('click', '[data-hidden-form]', function(e) {
    e.preventDefault();

    var element = $(this),
        hiddenForm = element.data('hidden-form'),
        method = hiddenForm.method || 'post',
        action = hiddenForm.action,
        confirm = hiddenForm.confirm || null,
        data = hiddenForm.data || {},
        appendTo = hiddenForm.appendTo || null,
        baseData = {token: csrfToken};

    data = $.extend(true, {}, baseData, data);

    if(appendTo) {
        appendTo = element.closest(appendTo);
        if(!appendTo.length) appendTo = element.offsetParent().find(appendTo).first();
        if(!appendTo.length) appendTo = $(appendTo).first();
    }

    if(method && action) {
        var form = cph.buildHiddenForm(method, action, data);

        form.data('always-callback', function() {
            form.remove();
        });

        if(confirm) {
            form.data('confirm', confirm);
            form.data('confirm-cancel', function() {
                form.remove();
            });
        }

        if(appendTo && appendTo.length) {
            form.appendTo(appendTo).submit();
        } else {
            if(element.closest('form').length) {
                element.closest('form').after(form);
                form.submit();
            } else {
                form.insertAfter(element).submit();
            }
        }
    }
});

$(document).on('keydown', '.btn[role="button"]:not(a)', function(e) {
    if(e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
        e.preventDefault();
        $(this).trigger('click');
    }
});

$(document).on('click', '.password-toggle', function() {
    var clicked = $(this),
        input = clicked.parent().find('input'),
        showClass = clicked.data('show-class'),
        hideClass = clicked.data('hide-class');

    if(input.length && showClass && hideClass) {
        if(clicked.hasClass(showClass)) {
            input.attr('type', 'text');
            clicked.removeClass(showClass).addClass(hideClass);
            input.focus();
        } else {
            input.attr('type', 'password');
            clicked.removeClass(hideClass).addClass(showClass);
            input.focus();
        }
    }
});

$(document).on('click', '.lockable-toggle', function() {
    var clicked = $(this),
        input = clicked.parent().find('input'),
        unlockedClass = clicked.data('lockable-unlocked-class'),
        lockedClass = clicked.data('lockable-locked-class'),
        confirm = clicked.data('lockable-unlock-confirm');

    if(input.length && lockedClass && unlockedClass) {
        if(clicked.hasClass(lockedClass)) {
            var enableInput = function() {
                input.prop('disabled', false);
                clicked.removeClass(lockedClass).addClass(unlockedClass);
                input.focus();
            };

            if(confirm && confirm !== 'undefined') {
                cph.loadLitbox(function() {
                    $.litConfirm(confirm, enableInput, $.noop(), {width: 300});
                });
            } else {
                enableInput();
            }
        } else {
            input.prop('disabled', true);
            clicked.removeClass(unlockedClass).addClass(lockedClass);
            input.focus();
        }
    }

});

$(document).on('click', '.hidden-help', function() {
    var clicked = $(this),
        children = clicked.find('> *');

    if(clicked.is('.expanded')) {
        children.slideUp(180, function() {
            clicked.removeClass('shrinking expanded');
        });
    } else {
        children.slideDown(180, function() {
            clicked.removeClass('expanding').addClass('expanded');
        });
    }
});

$(document).on('submit', '.admin-page__bulk-actions-form', function(e) {
    e.preventDefault();

    const form = $(this);
    const actionVar = form.data('action-var');
    const actionSelect = form.find('select[name="' + actionVar + '"]');
    const actionSelected = actionSelect.val();
    const selectedOption = form.find('option[value="' + actionSelected + '"]');

    let startAction = form.data('action');
    if(!startAction) {
        startAction = form.attr('action');
        form.data('action', startAction);
    }

    form.removeClass('shake');
    setTimeout(function() {
        if(!actionSelected.length) {
            form.addClass('shake');
            return;
        }

        const valueInputs = $('.frm-' + actionVar).find('[name="' + actionVar + '_values"]');
        const selected = $.map($('.ckb-' + actionVar + ':checked'), function(n) {
            return n.value;
        }).join(',');

        if(!selected.length) {
            form.addClass('shake');
            return;
        }

        valueInputs.val(selected);
        const action = selectedOption.data('action-url') || startAction;
        if(action.startsWith('javascript:')) {
            const jsFunction = action.replace('javascript:', '').replace(/\(\);?/, '');
            if(typeof window[jsFunction] === 'function') {
                window[jsFunction]();
            }
            return;
        }

        form.attr('action', selectedOption.data('action-url') || startAction);
        cph.processAjaxSubmit(form);
    }, 0);
});

$(document).on('change', '.admin-bulk-checkbox-toggle', function() {
    var toggle = $(this),
        actionVar = toggle.data('action-var'),
        els = $('.ckb-' + actionVar);

    if(els.length) {
        els.prop('checked', toggle.is(':checked'));
    }
});

$(document).on('click', 'a.popup', function(e) {
    var clicked = $(this),
        url = clicked.attr('href');

    e.preventDefault();
    cph.popupWindow(url, 550, 300);
});

$(document).on('click', '.panel__close', function() {
    var panel = $(this).closest('.panel');
    panel.hide(250, function() {
        panel.remove();
    });
});

$(document).on('click', '.notification-close', function(e) {
    e.preventDefault();
    var notification = $(this).closest('.notification');
    notification.slideUp(180, function() {
        notification.removeClass('show');
    });
});

$(document).on('click', '[data-scrollto]', function(e) {
    e.preventDefault();

    var clicked = $(this),
        value = clicked.data('scrollto'),
        target = $('#' + value);

    if(target.length) {
        fromTop = cph.getAdjustedTopOffset(target);
        $('html, body').animate({
            scrollTop: fromTop
        }, 550);
    }
});

$(document).on('change', '.change-submit, .submit-on-change', function() {
    $(this).closest('form').trigger('submit');
});

$(document).on('change', 'input[type=email]', function() {
    var changed = $(this);
    changed.val($.trim(changed.val()));
});

$(document).on('submit', '.ajax-submit', function(e) {
    const originalEvent = e.originalEvent || {};
    const submitter = $(originalEvent.submitter);

    let useLoader, useResponse;
    if(submitter.length) {
        let loaderId = submitter.data('loader-id'),
            responseId = submitter.data('response-id');

        if(loaderId)
            useLoader = $('#' + loaderId.replace(/^#/, ''));

        if(responseId)
            useResponse = $('#' + responseId.replace(/^#/, ''));
    }

    e.preventDefault();
    const form = $(this);
    const confirmDialog = form.data('confirm');

    let onNo = $.noop(),
        onYes = function() {
            cph.processAjaxSubmit(form, useLoader, useResponse);
        };

    if(form.data('confirm-cancel'))
        onNo = form.data('confirm-cancel');

    if(confirmDialog && confirmDialog !== 'undefined') {
        cph.loadLitbox(function() {
            $.litConfirm(confirmDialog, onYes, onNo, {width: '20em'});
        });
    } else {
        cph.processAjaxSubmit(form, useLoader, useResponse);
    }
});

$(document).on('click', '.cancel-button', function(e) {
    e.preventDefault();
    var clicked = $(this);

    if(cph.litboxIsLoaded()) {
        if(Litbox.get(clicked).length) {
            Litbox.hide(clicked);
            return true;
        }
    }

    if(cph.tippedIsLoaded() && Tipped.findElement(clicked[0])) {
        Tipped.hide(clicked[0]);
        return true;
    }

    location.href = clicked.attr('href');
});

$(document).on('click', '.more-info', function(e) {
    var clicked = $(this),
        showId = clicked.data('show'),
        toShow;

    if(!showId) return;
    toShow = $('#' + showId);
    if(!toShow.length) return;

    e.preventDefault();

    if(clicked.hasClass('showing')) {
        clicked.removeClass('showing');
        toShow.slideUp(140);
    } else {
        clicked.addClass('showing');
        toShow.slideDown(280);
    }
});

$(document).one('click', '[data-litbox]', function(e) {
    e.preventDefault();
    var clicked = $(this);
    if(!cph.litboxIsLoaded()) {
        cph.loadLitbox(function() {
            clicked.trigger('click');
        });
    }
});

$.inViewport = function(el, padding) {
    var elementTop = $(el).offset().top;
    var elementBottom = elementTop + $(el).outerHeight();

    elementTop = elementTop + (padding);
    elementBottom = elementBottom + (padding);

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
/*
 * Functions run at page load, ajax load and some onResize
 *
 * Requires:
 * _script-loaders.js
 *
 */
var cph = cph || {};
(function($) {
    cph.initFixedHeader = function() {
        var body = $('body'),
            pageWrap = $('#page-wrap');

        if(body.hasClass('fixed-header')) {
            pageWrap.css({paddingTop: $('#header').outerHeight()});
        } else {
            pageWrap.css({paddingTop: '0'});
        }
    };

    cph.initPushMenuToggle = function() {
        var aboveHeader = $('#above-header:visible'),
            container = $('.push-menu__fixed-toggles:visible'),
            toggles = container.find('.push-menu__toggle:visible'),
            aboveHeaderHeight, scrollTop;

        $(window).off('.pushMenuToggle');

        if(!aboveHeader.length || !toggles.length) // WILL NOT FIRE IF NOTHING ABOVE HEADER OR NO TOGGLES AVAILABLE
            return;

        aboveHeaderHeight = aboveHeader.outerHeight();
        scrollTop = $(window).scrollTop();

        if(scrollTop < aboveHeaderHeight) {
            container.css({position: 'absolute', top: aboveHeaderHeight});
        } else {
            container.css({position: 'fixed', top: 0});
        }

        $(window).on('scroll.pushMenuToggle', $.throttle(250, function() {
            scrollTop = $(window).scrollTop();
            if(scrollTop < aboveHeaderHeight) {
                container.css({position: 'absolute', top: aboveHeaderHeight});
            } else {
                container.css({position: 'fixed', top: 0});
            }
        }));
    };

    cph.initSubMenu = function() {
        var subMenuOuter = $('#sub-menu'),
            subMenuScroll = subMenuOuter.find('.sub-menu__scroll').first(),
            activeItem = subMenuOuter.find('.sub-menu__button--active').first();

        if(!subMenuOuter.length || !activeItem.length)
            return;

        if(subMenuScroll[0].scrollWidth > subMenuScroll[0].clientWidth) {
            subMenuScroll.scrollLeft(activeItem.position().left - 100);
        }
    };

    cph.initKeyStops = function() {
        var inputs = $('[data-keystop]').not('.ks-applied-applied');
        if(!inputs.length)
            return;

        inputs.each(function() {
            var input = $(this),
                keystop = input.data('keystop'),
                keystops = [];

            if(keystop) keystops = keystop.split(',');

            if(keystops.length) {
                $.each(keystops, function(i, key) {
                    input.keydown(function(e) {
                        if(e.key === key) {
                            e.preventDefault();
                        }
                    });
                });
            }
        });
    };

    cph.initMasks = function() {
        var inputs = $('[data-masked]').not('.mask-applied');
        if(!inputs.length)
            return;

        cph.loadMask(function() { // _script-loaders.js
            inputs.each(function() {
                var input = $(this),
                    mask = input.data('masked'),
                    options = input.data('masked-options') || {};

                input.mask(mask, options);
                input.addClass('mask-applied');
            });
        });
    };

    cph.initSortable = function() {
        var blocks = $('[data-sortable]').not('.sortable-applied');

        if(!blocks.length)
            return;

        cph.loadSortable(function() {
            $.each(blocks, function(i) {
                // https://github.com/SortableJS/Sortable
                // https://sortablejs.github.io/Sortable/

                var baseOptions = {
                    group    : 'sortableGroup' + i,
                    easing   : 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    animation: 350
                };

                var options = $.extend({}, baseOptions, $(blocks[i]).data('sortable'));
                var callback = $(blocks[i]).data('sortable-callback');

                if(callback && callback !== 'undefined') {
                    options.onUpdate = function(evt) {
                        $.each(callback.split(','), function(k, v) {
                            if($.isFunction(window[v])) {
                                window[v].call(this, evt);
                            }
                        });
                    };
                }

                var toSort = Sortable.create(blocks[i], options);

                $(blocks[i]).addClass('sortable-applied').data('sortable', toSort);
            });
        });
    };

    cph.initCookieBlocks = function() {
        var blocks = $('.js_cookie-block'),
            block = [], name = [], duration = [], close = [];

        if(!blocks.length) return;

        blocks.each(function(i) {
            block[i] = $(this);
            name[i] = block[i].data('name');
            duration[i] = block[i].data('duration');
            close[i] = block[i].find('.js_cookie-block__close');

            if(!$.cookie.get('cb.' + name[i])) {
                block[i].show(0, function() {
                    close[i].one('click', function() {
                        block[i].slideUp(180, function() {
                            block[i].remove();
                            if(duration[i]) {
                                $.cookie.set('cb.' + name[i], 1, duration[i]);
                            } else {
                                $.cookie.set('cb.' + name[i], 1);
                            }
                        });
                    });
                });
            }
        });
    };

    cph.initTooltips = function() { // requires tipped.js (external)
        var tooltipIcons = $('.tooltip-icon'),
            tooltips = $('[data-tooltip]');

        if(!tooltipIcons.length && !tooltips.length)
            return;

        cph.loadTipped(function() {
            if(tooltipIcons.length) {
                Tipped.create(tooltipIcons, {
                    skin    : 'primary',
                    size    : 'large',
                    position: 'topright',
                    maxWidth: 300,
                    zIndex  : 10000
                });
            }

            if(tooltips.length) {
                $.each(tooltips, function() {
                    var config = {
                            skin    : 'primary',
                            position: 'top',
                            maxWidth: 300,
                            zIndex  : 10000
                        },
                        options = $(this).data('tooltip');
                    $.extend(config, options);
                    Tipped.create($(this), config);
                });
            }
        });
    };

    cph.initSlimImage = function() {
        var blocks = $('.editable-image:visible').not('.slim');
        if(!blocks.length)
            return;

        cph.slimImageRemoved = function(data, slim) {
            var el = $(slim.element),
                imageId = el.attr('data-meta-image-id');

            if(imageId) {
                var loader = $('<span/>', {
                    class: 'loader-bar show'
                }).prependTo(el);

                var deleted = $.post('/image/' + imageId + '/delete');
                deleted.done(function() {
                    loader.removeClass('show');
                    //el.attr('data-meta-delete-image-id', imageId);

                    el.slim('destroy');

                    el.removeAttr('data-will-remove');
                    el.removeAttr('data-did-remove');
                    el.removeAttr('data-meta-image-id');
                    el.find('img:first').remove();

                    setTimeout(function() {
                        el.slim();
                        el.trigger('slimImageDeleted');
                    }, 0);
                });
            }
        };

        cph.slimImageWillRemove = function(data, remove) {
            cph.loadLitbox(function() {
                $.litConfirm('<p>Are you sure you want to delete this image?</p><p>This action can\'t be undone.</p>', remove);
            });
        };

        cph.slimImageDidInit = function(data) {
            $(this._element).trigger('slimDidInit', data);
            $(this._element).trigger('slimForceWidth', data);
        };

        cph.slimImageWillTransform = function(data, ready) {
            $(this._element).trigger('slimForceWidth', data);
            setTimeout(function() {
                ready(data);
            }, 0);
        };

        cph.slimImageDidTransform = function(data) { /* unused */ };

        $(window).off('.slimImageCustom');
        cph.loadSlimImage(function() { // _script-loaders.js
            blocks.each(function() {
                var block = $(this),
                    imageId = block.data('meta-image-id'),
                    keepHeight = block.data('force-outer-height'),
                    blockHeight, blockWidth, label;

                if(keepHeight && keepHeight !== 'undefined' && (keepHeight !== true && keepHeight !== 1)) {
                    block.css({height: keepHeight});
                }

                if(!block.is('input')) {
                    label = block.find('label:first');
                    label.insertBefore(block);
                }

                block.attr('data-did-init', 'cph.slimImageDidInit');

                if(keepHeight && keepHeight !== 'undefined') {
                    block.attr('data-will-transform', 'cph.slimImageWillTransform');
                    //block.attr('data-did-transform', 'cph.slimImageDidTransform');

                    block.on('slimForceWidth', function(e, data) {
                        if(!blockHeight) blockHeight = block.outerHeight();
                        if(blockHeight) blockWidth = blockHeight / (data.output.height / data.output.width);
                        if(blockWidth) block.css({width: parseInt(blockWidth) + 'px', maxWidth: '100%'});
                    });
                }

                if(imageId) {
                    block.attr('data-will-remove', 'cph.slimImageWillRemove');
                    block.attr('data-did-remove', 'cph.slimImageRemoved');
                }

                var cropper = block.slim(); // automatically adds class .slim, so I don't need to

                if(imageId) {
                    $(cropper).css('cursor', 'default');
                    $(cropper).find('.slim-file-hopper').css({left: '-1000em', right: 'auto', width: 'auto'});

                    $(window).off('.slimImageCustom');
                    $(window).on('dragover.slimImageCustom drop.slimImageCustom', function(e) {
                        e.preventDefault();
                    });
                }
            });
        });
    };

    cph.initTabs = function() {
        var outerBlocks = $('.tabbed-blocks').not('.tabbed-added'),
            supportsHash = ('onhashchange' in window && (document.documentMode === undefined || document.documentMode > 7));

        if(!supportsHash || !outerBlocks.length) return;

        outerBlocks.each(function() {
            var outerBlock = $(this),
                theBlocks = $(this).find('[data-tabbed-name]'),
                theTabs = $('<div/>', {class: 'tabbed-tabs'}),
                firstTabName;

            theBlocks.each(function(i) {
                var theBlock = $(this).addClass('tabbed-block'),
                    blockName = theBlock.data('tabbed-name'),
                    blockTitle = theBlock.data('tabbed-title') || blockName;

                $('<a/>', {
                    class: 'tabbed-tab',
                    href : '#' + blockName,
                    text : blockTitle
                }).attr('data-tabbed-name', blockName).appendTo(theTabs);

                if(i === 0) firstTabName = blockName;
            });

            if(theTabs.find('.tabbed-tab').length) {
                outerBlock.before(theTabs);

                var checkHash = function() {
                    var hash = window.location.hash.slice(1);
                    if(!hash) hash = firstTabName;

                    theTabs.find('.tabbed-tab').removeClass('active').filter('[data-tabbed-name="' + hash + '"]').addClass('active');
                    theBlocks.removeClass('active').filter('[data-tabbed-name="' + hash + '"]').addClass('active');
                };

                $(window).on('hashchange', checkHash);
                checkHash();
            }

            outerBlock.addClass('tabbed-added');
        });
    };

    cph.initAutoSize = function() {
        var blocks = $('.autosize').not('.as-applied');
        if(!blocks.length)
            return;

        cph.loadAutoSize(function() { // _script-loaders.js
            blocks.each(function() {
                autosize($(this));
                $(this).addClass('as-applied');
            });
        });
    };

    cph.initMaxLength = function() {
        var blocks = $('input[maxlength], textarea[maxlength]').not('.ml-applied');
        if(!blocks.length)
            return;

        blocks.each(function() {
            var block = $(this),
                maxLength = block.attr('maxlength');

            var counter = $('<span/>', {
                text : maxLength,
                class: 'ml-counter'
            });

            var container = $('<div/>', {
                html : counter,
                class: 'ml-container'
            });

            block.addClass('ml-applied');
            block.after(container);

            var process = function() {
                block.val(block.val().substring(0, maxLength));
                var charsRemaining = maxLength - parseInt(block.val().length);
                counter.text(charsRemaining);
            };

            block.keyup(process);

            process();
        });
    };

    cph.initStickyPanel = function() {
        const sbs = $('#sticky-panel');
        const inner = sbs.find('> .sticky-panel__inner');
        const isTop = sbs.hasClass('sticky-panel--top');

        if(!sbs.length || !inner.length) return;

        const resetStickyPanel = $.debounce(50, function() {
            sbs.css('height', '').removeClass('fixed');

            const fixBottomUntil = (sbs.offset().top + sbs.height()) - $(window).height();
            const fixTopAt = sbs.offset().top;

            sbs.css('height', sbs.height());

            $(window).off('scroll.stickyPanel');
            $(window).on('scroll.stickyPanel', $.throttle(150, function() {
                if(isTop) {
                    if($(window).scrollTop() < fixTopAt) {
                        if(sbs.hasClass('fixed'))
                            sbs.removeClass('fixed');
                    } else {
                        if(!sbs.hasClass('fixed'))
                            sbs.addClass('fixed');
                    }
                } else {
                    if($(window).scrollTop() > fixBottomUntil) {
                        if(sbs.hasClass('fixed'))
                            sbs.removeClass('fixed');
                    } else {
                        if(!sbs.hasClass('fixed'))
                            sbs.addClass('fixed');
                    }
                }
            })).trigger('scroll.stickyPanel');
        });

        resetStickyPanel();

        if(typeof ResizeObserver === 'function') {
            new ResizeObserver(function() {
                resetStickyPanel();
            }).observe(inner[0]);
        } else {
            $(window).on('resize', function() {
                resetStickyPanel();
            });
        }
    };

    cph.initSelectize = function() {
        var blocks = $('[data-selectize]:visible').not('.selectized');
        if(!blocks.length)
            return;

        var eventHandler = function(name) {
            return function() {
                if(typeof name === 'string' && typeof window[name] === 'function')
                    return window[name].apply(this, arguments); // changed to pass 'this' to function
                //return window[name].apply(null, arguments);
                return false;
            };
        };

        cph.loadSelectize(function() {

            blocks.each(function() {
                // https://github.com/selectize/selectize.js
                var block = $(this),
                    baseOptions = {
                        create : block.is('input, textarea'),
                        plugins: {}
                    },
                    options = block.data('selectize') || {},
                    plugins = {};

                if(options.removeButton) {
                    plugins['remove_button'] = {label: '&#x2715;'};
                    delete options.removeButton;
                }

                if(options.restoreOnBackspace) {
                    plugins['restore_on_backspace'] = {};
                    delete options.restoreOnBackspace;
                }

                $.each(options, function(key, value) {
                    if(key.match(/^on[A-Z]/))
                        options[key] = eventHandler(value);

                    if(key === 'score')
                        options[key] = eventHandler(value);

                    var match = key.match(/^render\.([a-z]+)/);
                    if(match && match.length === 2) {
                        if(typeof options.render === 'undefined') options.render = {};
                        options.render[match.pop()] = eventHandler(value);
                        delete options[match.pop()];
                    }
                });

                if(options.dragDrop) {
                    cph.loadJQueryUI(function() {
                        plugins['drag_drop'] = {};
                        delete options.dragDrop;
                        continueLoadingSelectize();
                    });
                } else {
                    continueLoadingSelectize();
                }

                function continueLoadingSelectize() {
                    options.plugins = plugins;
                    options = $.extend({}, baseOptions, options);

                    if(cph.isInLitbox(block)) {
                        options.dropdownParent = 'body';
                        options.onDropdownOpen = function(dropdown) {
                            var zIndex = Litbox.getZIndex(block);
                            dropdown.removeClass('expand').css({zIndex: zIndex + 1});
                        };
                    }

                    options.onInitialize = function() {
                        this.$wrapper.removeClass('change-submit').find('.change-submit').removeClass('change-submit');
                    };

                    block.selectize(options);
                }
            });
        });
    };

    cph.initTableSorter = function() {
        var blocks = $('table[data-tablesorter]').not('.tablesorter');

        if(!blocks.length) return;

        cph.loadTableSorter(function() {
            blocks.each(function() {
                var table = $(this),
                    wrap = table.closest('.table-wrap'),
                    paginationContainer = $('.tablesorter-pagination-container'),
                    data = table.data('tablesorter'),
                    paginate = (typeof data.paginate !== 'undefined') ? data.paginate : false,
                    showFilter = (typeof data.showFilter !== 'undefined') ? data.showFilter : true,
                    saveSort = (typeof data.saveSort !== 'undefined') ? data.saveSort : true,
                    widgets = [], pagination;

                widgets.push('zebra');
                widgets.push('columns');
                if(saveSort) widgets.push('saveSort');
                if(showFilter) widgets.push('filter');

                delete data.paginate;
                delete data.showFilter;
                delete data.saveSort;

                var options = {
                    debug         : false,
                    sortReset     : true,
                    sortRestart   : true,
                    widgets       : widgets,
                    showProcessing: true,
                    textExtraction: function(node, table, cellIndex) {
                        var n = $(node);
                        return n.attr('data-sort') || n.text();
                    },
                    widgetOptions : {
                        filter_saveFilters: true
                    }
                };

                options = $.extend({}, options, data);

                table.tablesorter(options);

                var checkShowHideConditions = function() {
                    if(table.find('.tablesorter-headerAsc, .tablesorter-headerDesc, tr.filtered').length) {
                        table.removeClass('show-not-filtered').addClass('show-filtered');
                    } else {
                        table.removeClass('show-filtered').addClass('show-not-filtered');
                    }
                };

                table.on('sortEnd filterEnd', function() {
                    checkShowHideConditions();
                });

                checkShowHideConditions();

                if($.isArray(paginate)) {
                    pagination = '<div class="tablesorter-pagination"> ' +
                        '<div class="tablesorter-pagination-section pagination-buttons"> ' +
                        '<button class="btn btn-outlined p2-x border-primary text-primary first"><i class="fa fa-angle-double-left"></i></button> ' +
                        '<button class="btn btn-outlined p2-x border-primary text-primary prev"><i class="fa fa-angle-left"></i></button> ' +
                        '<span class="pagedisplay"></span> ' +
                        '<button class="btn btn-outlined p2-x border-primary text-primary next"><i class="fa fa-angle-right"></i></button> ' +
                        '<button class="btn btn-outlined p2-x border-primary text-primary last"><i class="fa fa-angle-double-right"></i></button> ' +
                        '</div> ' +
                        '<div class="tablesorter-pagination-section pagination-selects"> ';

                    var default_pages = paginate[0];

                    if(paginate.length > 1) {
                        pagination += '<label>Per Page</label> ' +
                            '<select class="pagesize" title="Results Per Page"> ';

                        $.each(paginate, function(i, v) {
                            pagination += '<option value="' + v + '">' + v + '</option> ';
                        });

                        pagination += '</select> ';
                    }

                    pagination += '<label>Go To Page</label> ';
                    pagination += '<select class="gotoPage" title="Page Number"></select> ';
                    pagination += '</div> ';
                    pagination += '</div> ';

                    pagination = $(pagination);

                    if(paginationContainer.length) paginationContainer.html(pagination);
                    else if(wrap.length) wrap.before(pagination);
                    else table.before(pagination);

                    table.tablesorterPager({
                        container   : pagination,
                        updateArrows: true,
                        page        : 0,
                        startPage   : 0,
                        size        : default_pages,
                        savePages   : false,
                        fixedHeight : false,
                        pageReset   : true
                    });
                }
            });
        });
    };

    cph.initDateRangePicker = function() {
        var blocks = $('[data-datepicker]').not('.datepicker-applied');
        if(!blocks.length)
            return;

        cph.loadDateRangePicker(function() {
            blocks.each(function() {
                // http://www.daterangepicker.com/#config
                var block = $(this),
                    baseOptions = {
                        singleDatePicker   : true,
                        showDropdowns      : true,
                        autoUpdateInput    : false,
                        autoApply          : true,
                        buttonClasses      : 'btn',
                        applyButtonClasses : 'btn',
                        cancelButtonClasses: 'btn btn-outlined'
                    },
                    options = $.extend({}, baseOptions, block.data('datepicker'));

                if(cph.isInLitbox(block)) {
                    options.parentEl = '.litbox--active .litbox__inner';
                }

                block.daterangepicker(options);

                if(cph.isInLitbox(block)) {
                    block.on('show.daterangepicker', function(ev, picker) {
                        var zIndex = Litbox.getZIndex(block);
                        $(picker.container).css({zIndex: zIndex + 1});
                    });
                }

                block.on('apply.daterangepicker', function(ev, picker) {
                    var val = block.val();
                    block.val(picker.startDate.format(picker.locale.format));

                    if(val !== block.val())
                        block.trigger('change');
                });

                block.on('cancel.daterangepicker', function(ev, picker) {
                    if(typeof picker.locale.cancelLabel !== 'undefined' && picker.locale.cancelLabel.toLowerCase() === 'clear') {
                        var val = block.val();
                        block.val('');

                        if(val !== block.val())
                            block.trigger('change');
                    }
                });
            });
        });
    };

    cph.initTinyMCE = function() {
        var blocks = $('[data-html-editor]:visible').not('.html-editor-applied');
        if(!blocks.length)
            return;

        cph.loadTinyMCE(function() {
            blocks.each(function() {
                var block = $(this),
                    editorType = block.data('html-editor'),
                    editorOptions = block.data('html-editor-options'),
                    customMenus = editorOptions['custom_menus'] || [],
                    customToolbar = [];

                delete editorOptions['custom_menus'];

                customMenus.forEach(function(customMenu) {
                    if(customMenu && customMenu.options) {
                        customToolbar.push('custom-menu-' + customMenu.key);
                    }
                });

                var mceConfig = {
                    allow_conditional_comments  : false,
                    forced_root_block           : 'p',
                    keep_styles                 : false,
                    branding                    : false,
                    menubar                     : false,
                    statusbar                   : false,
                    plugins                     : 'lists,autoresize,quickbars',
                    toolbar                     : 'bold italic numlist bullist',
                    toolbar_mode                : 'wrap',
                    toolbar_sticky              : true,
                    quickbars_selection_toolbar : 'bold italic quicklink',
                    quickbars_insert_toolbar    : false,
                    quickbars_image_toolbar     : false,
                    link_context_toolbar        : true,
                    link_assume_external_targets: false,
                    link_title                  : false,
                    min_height                  : 300,
                    default_link_target         : '_self',
                    content_css                 : '/css/style.css',
                    content_style               : 'body { width: auto; margin: .65em; font-size: 100%; }',
                    setup                       : function(editor) {
                        editor.on('remove', function() {
                            block.removeClass('html-editor-applied');
                        });

                        customMenus.forEach(function(customMenu) {
                            if(customMenu && customMenu.options) {
                                var items = [];
                                customMenu.options.forEach(function(item) {
                                    items.push({
                                        type           : 'nestedmenuitem',
                                        text           : item.label,
                                        getSubmenuItems: function() {
                                            var submenuItems = [];
                                            item.options.forEach(function(submenuItem) {
                                                submenuItems.push({
                                                    type    : 'menuitem',
                                                    text    : submenuItem.name,
                                                    onAction: function() {
                                                        editor.insertContent(submenuItem.value);
                                                    }
                                                });
                                            });
                                            return submenuItems;
                                        }
                                    });
                                });

                                if(items.length) {
                                    editor.ui.registry.addMenuButton('custom-menu-' + customMenu.key, {
                                        text : customMenu.label,
                                        fetch: function(callback) {
                                            callback(items);
                                        }
                                    });
                                }
                            }
                        });
                    }
                };

                if(editorType === 'email') {
                    mceConfig = $.extend({}, mceConfig, {
                        plugins                     : 'paste,autolink,code,fullscreen,link,table,quickbars,autoresize',
                        toolbar                     : 'undo redo | bold italic link | alignleft aligncenter alignright | removeformat code fullscreen | format',
                        contextmenu                 : 'link',
                        height                      : '450px',
                        default_link_target         : '_blank',
                        target_list                 : false,
                        forced_root_block           : false,
                        paste_block_drop            : true,
                        link_assume_external_targets: true,
                        autoresize_bottom_margin    : 10,
                        valid_elements              : 'a[!href|style|target],p,ul,ol,li,strong/b,em/i,br',
                        valid_styles                : {'a,span,div': 'font-size,color,font-weight,line-height'},
                        formats                     : {
                            alignleft  : {block: 'div', attributes: {align: 'left'}, styles: {textAlign: 'left'}},
                            aligncenter: {block: 'div', attributes: {align: 'center'}, styles: {textAlign: 'center'}},
                            alignright : {block: 'div', attributes: {align: 'right'}, styles: {textAlign: 'right'}}
                        }
                    });
                }

                if(editorType === 'basic') {
                    mceConfig = $.extend({}, mceConfig, {
                        plugins         : 'lists,link,autoresize',
                        toolbar         : 'undo redo | bold italic link numlist bullist',
                        valid_elements  : 'a[!href|style|target],p,ul,ol,li,strong/b,em/i,br',
                        paste_block_drop: true
                    });
                }

                if(editorType === 'full') {
                    mceConfig = $.extend({}, mceConfig, {
                        plugins         : 'lists,paste,autolink,code,fullscreen,link,table,quickbars,autoresize',
                        toolbar         : 'undo redo | styleselect | fontsizeselect | bullist numlist | indent outdent | bold italic underline link | forecolor | alignleft aligncenter alignright | removeformat code fullscreen',
                        fontsize_formats: '0.85em .925em 1em 1.1em 1.15em 1.2em 1.25em',
                        paste_block_drop: true
                    });
                }

                if(editorType === 'inline') {
                    mceConfig = $.extend({}, mceConfig, {
                        inline                  : true,
                        autoresize_bottom_margin: 50,
                        setup                   : function(editor) {
                            editor.on('init', function() {
                                editor.fire('focus');
                                setTimeout(function() {
                                    editor.selection.select(editor.getBody(), true);
                                    editor.selection.collapse(false);
                                }, 0);
                            }).on('focus blur change', function() {
                                editor.save();
                            }).on('remove', function() {
                                block.removeClass('html-editor-applied');
                            });
                        }
                    });
                }

                if(editorOptions)
                    mceConfig = $.extend({}, mceConfig, editorOptions);

                if(customToolbar.length)
                    mceConfig.toolbar += ' | ' + customToolbar.join(' ');

                block.tinymce(mceConfig);
                block.addClass('html-editor-applied');
            });
        });
    };
})(jQuery);
$(document).on('submit', '.inline-editable__form', function(e) {
    e.preventDefault();
});

$(document).on('click', '.inline-editable__button', function(e) {
    e.preventDefault();

    var clicked = $(this),
        parent = clicked.closest('.inline-editable'),
        setWidth = parent.data('set-width'),
        value = parent.find('.inline-editable__value'),
        form = parent.find('.inline-editable__form'),
        edit = parent.find('.inline-editable__edit-button'),
        save = parent.find('.inline-editable__save-button'),
        saveCallback = form.data('save-callback'),
        cancel = parent.find('.inline-editable__cancel-button'),
        deleet = parent.find('.inline-editable__delete-button'),
        editables = form.find('input, textarea, select, .editable-image, [data-html-editor]').not('[type="hidden"]');

    $(document).trigger('click');
    $(document).one('inlineEditableOpened', function() {
        cancel.trigger('click');
    });

    if(form.is('.submitting')) return;

    editables.each(function() {
        var editable = $(this);
        if(editable.is('.editable-image')) {
            editable.off('slimImageDeleted');
            editable.one('slimImageDeleted', function() {
                cancel.one('click.imageDeletedHandler', function() {
                    save.trigger('click');
                });
            });
        }
    });

    var layover = $('.inline-editable__layover');
    if(!layover.length) $('<div/>', {class: 'inline-editable__layover'}).prependTo($('#page-wrap'));

    if(clicked.is(edit)) {

        if(setWidth) parent.css({width: value.outerWidth(), maxWidth: '100%'});

        value.hide();
        form.show();
        layover.show();

        form.css('z-index', 101);

        editables.each(function(i) {
            var editable = $(this);

            if(editable.is('.editable-image:not(.slim)')) {
                cph.initSlimImage();

                /* to open file picker on load. Was annoying.
                editable.one('slimInit', function(e, data) {
                    if(typeof data.meta.imageId === 'undefined')
                        editable.find('.slim-file-hopper').trigger('click');
                });*/
            }

            if(editable.is('[data-html-editor]')) {
                cph.loadTinyMCE(function() {
                    var mceId = editable.attr('id'),
                        mce = tinymce.get(mceId);
                    if(mce) mce.destroy();
                    cph.initTinyMCE();
                });
            }

            if(editable.is('[data-selectize]')) {
                cph.loadSelectize(function() {
                    cph.initSelectize();
                    if(i === 0) { // to prevent focusing selectize if not first element
                        setTimeout(function() {
                            editable[0].selectize.focus();
                        }, 0);
                    }
                });
            }

            if(editable.is('.autosize.as-applied')) autosize.update(editable[0]);
        });

        $(document).on('keydown.inlineEditable keypress.inlineEditable', function(e) {
            if(e.key === 'Backspace' && !$(e.target).closest(parent).length) {
                e.preventDefault();
            }
        });

        $(window).on('hashchange.inlineEditable', function() {
            cancel.trigger('click');
        });

        cph.tabWithin(form);

        // To focus and move cursor to end of form.
        var firstEditable = editables.first(),
            firstEditableValue = firstEditable.val();

        firstEditable.focus();
        firstEditable.val('');
        firstEditable.val(firstEditableValue);

    } else if(clicked.is(save)) {

        form.data('success-callback', function() {
            if(saveCallback)
                cph.callbackCaller(saveCallback);

            layover.hide();
            checkDomInit();

            editables.each(function() {
                var editable = $(this);
                if(editable.is('.html-editor-applied')) {
                    var mceId = editable.attr('id'),
                        mce = tinymce.get(mceId);
                    if(mce) mce.destroy();
                }
            });
        });

        cph.processAjaxSubmit(form);

    } else if(clicked.is(cancel)) {

        editables.each(function() {
            var editable = $(this);

            if(editable.is('.html-editor-applied')) {
                var mceId = editable.attr('id'),
                    mce = tinymce.get(mceId);
                if(mce) {
                    mce.resetContent();
                    mce.destroy();
                }
            }

            if(editable.is('.autosize.as-applied'))
                autosize.update(editable[0]);

            if(editable.is('.editable-image.slim'))
                editable.slim('destroy');

            if(editable.is('.selectized')) {
                editable[0].selectize.destroy();
            }
        });

        form[0].reset();

        form.find('.response').removeClass('show').hide();

        value.show();
        form.hide();
        layover.hide();

    } else if(clicked.is(deleet)) {

        var method = deleet.data('method'),
            path = deleet.data('path'),
            confirm = deleet.data('confirm');

        if(confirm && confirm !== 'undefined') {
            cph.loadLitbox(function() {
                $.litConfirm(confirm, function() {
                    form.attr('method', method).attr('action', path);
                    save.trigger('click');
                });
            });
        } else {
            form.attr('method', method).attr('action', path);
            save.trigger('click');
        }

    }

    if(!clicked.is(edit)) {
        cancel.off('.imageDeletedHandler');
        $(document).off('.inlineEditable');
        $(window).off('.inlineEditable');
    }
});
/* requires _functions.js */
var cph = cph || {};
(function($) {
    var topLoaderBar = $('#top-loader-bar');

    var loaderBarNum = 0;
    cph.showLoaderBar = function(element, callback) {
        var el = element.first(),
            parent = el.offsetParent(),
            eventNamespace = el.data('loader-ns'),
            fixedPoint, top, left, right, triggered, undoFixed;

        if(!eventNamespace) {
            eventNamespace = 'loaderBar' + (++loaderBarNum);
            el.data('loader-ns', eventNamespace);
        }

        el.off();

        if(el.is(topLoaderBar)) {
            cph.showTopLoaderBar();
        } else {
            el.css({top: 0, right: 0, left: 0}).removeClass('fixed').addClass('show');
        }

        setTimeout(function() {
            if($.isFunction(callback)) {
                callback.call(this);
            }
        }, 250);

        if(!el.is(topLoaderBar)) {
            var litbox = el.closest('.litbox__inner');

            if(litbox.length) {
                fixedPoint = litbox.offset().top - $(window).scrollTop();
                triggered = (el.offset().top - litbox.offset().top) < 0;
                top = fixedPoint;
            } else {
                fixedPoint = cph.getAdjustedTopOffset(el); // _functions.js
                triggered = fixedPoint < $(window).scrollTop();
                top = cph.getFixedHeaderHeight();
            }

            if(triggered) {
                left = el.offset().left;
                right = $(window).width() - el.outerWidth() - left;

                el.css({top: top, right: right, left: left}); // _functions.js
                el.addClass('fixed');

                $(window).on('scroll.' + eventNamespace, el, $.throttle(350, function(e) {
                    if(el.hasClass('fixed')) {
                        undoFixed = false;
                        if(litbox.length) {
                            if(litbox.scrollTop() === 0) undoFixed = true;
                        } else {
                            if(fixedPoint > $(window).scrollTop()) undoFixed = true;
                            if(parent.length && ((el.offset().top + el.outerHeight()) > (parent.offset().top + parent.outerHeight()))) undoFixed = true;
                        }

                        if(undoFixed) {
                            el.css({top: 0, right: 0, left: 0}).removeClass('fixed');
                            $(window).off(e);
                        }
                    }
                }));

                $(window).on('resize.' + eventNamespace, el, $.debounce(350, function() {
                    if(parent.length && el.hasClass('fixed')) {
                        left = parent.offset().left;
                        right = $(window).width() - parent.outerWidth() - left;
                        el.css({top: cph.getFixedHeaderHeight(), right: right, left: left}); // _functions.js
                    }
                }));
            }
        }
    };

    cph.hideLoaderBar = function(el) {
        var eventNamespace = el.data('loader-ns');
        if(eventNamespace)
            $(window).off('.' + eventNamespace);

        el.off();
        el.removeClass('show');
    };

    cph.hideAllLoaderBars = function(leaveOpen) {
        leaveOpen = $(leaveOpen);
        $('.loader-bar').not(leaveOpen).filter('.show').each(function() {
            cph.hideLoaderBar($(this));
        });
    };

    cph.showTopLoaderBar = function() {
        var headerHeight = cph.getFixedHeaderHeight();
        if(headerHeight === 0) {
            topLoaderBar.css({zIndex: 4, top: 0});
        } else {
            topLoaderBar.css({zIndex: 1, top: headerHeight}); // _functions.js
        }
        topLoaderBar.removeClass('show').addClass('show');
    };

    cph.hideTopLoaderBar = function() {
        if(topLoaderBar.length) topLoaderBar.removeClass('show');
    };
})(jQuery);
/* requires _functions.js */
var cph = cph || {};
(function($) {
    var pulseLoader = $('#pulse-loader-overlay'),
        body = $(document.body);

    cph.showPulseLoader = function(el) {
        el = $(el);
        var loader = el.find('.pulse-loader');
        if(!loader.length && el.is('.pulse-loader'))
            loader = el;
        if(loader.length) loader.addClass('show');
    };

    cph.hidePulseLoader = function(el) {
        el = $(el);
        var loader = el.find('.pulse-loader');
        if(!loader.length && el.is('.pulse-loader'))
            loader = el;
        if(loader.length) loader.removeClass('show');
    };

    cph.hideAllPulseLoaders = function(leaveOpen) {
        leaveOpen = $(leaveOpen);
        $('.pulse-loader').not(leaveOpen).filter('.show').each(function() {
            cph.hidePulseLoader($(this));
        });
    };

    cph.showPulseOverlay = function() {
        if(!pulseLoader.length) {
            pulseLoader = $('<div/>', {
                id  : 'pulse-loader-overlay',
                html: $('<div/>', {class: 'pulse-loader'})
            }).prependTo(body);
        }

        // quick timeout to assure css transition fires on overlay
        setTimeout(function() {
            pulseLoader.addClass('show');
            cph.freezeBody();
        }, 10);
    };

    cph.hidePulseOverlay = function() {
        if(pulseLoader.length) pulseLoader.removeClass('show');
        cph.unfreezeBody();
    };
})(jQuery);
jQuery(function($) {
	$(document).on('click', '.js_menu__trigger-toggle-focus', function(e) {
		e.preventDefault();
		$(this).find('.child-menu__toggle').focus();
	});

	$.fn.ariaExpandedFalse = function() {
		$(this).find('> a, > a .child-menu__toggle').attr('aria-expanded', 'false');
		return this;
	};

	var getParentsUntilMenu = function(toggle, menu) {
		return toggle.parentsUntil(menu, 'li.child-menu__visible');
	};

	var setChildHeight = function(child) {
		var childStyle = child.attr('style');

		child.css({
			transition: 'none',
			display   : 'block',
			visibility: 'hidden',
			height    : 'auto'
		});

		var childHeight = Math.ceil(child.outerHeight());
		child.data('height', childHeight);

		if(childStyle && childStyle !== 'undefined') child.attr('style', childStyle);
		else child.removeAttr('style');
	};

	var resizeVerticalMenu = function(parents) {
		var totalHeight = 0;
		$.each(parents, function() {
			var thisChild = $(this).find('ul:first'),
				thisHeight = thisChild.data('height');

			totalHeight += thisHeight;
			thisChild.css('height', totalHeight + 'px');
		});
	};

	var resetMenu = function(menu) {
		menu.find('.child-menu__visible, .child-menu__left').removeClass('child-menu__visible child-menu__left').ariaExpandedFalse();

		var namespace = menu.data('event-namespace');
		if(namespace) $(document).off('click.' + namespace);

		if(menu.hasClass('menu__vertical')) {
			var children = menu.find('.menu__has-children > ul');
			children.css('height', 0);

			setTimeout(function() {
				$.each(children, function() {
					setChildHeight($(this));
				});
			}, 400); // 400 gives time for height to reset to 0 for all submenu's
		}
	};

	$('.menu__multi-level').each(function(menuIndex) {
		var menu = $(this),
			isHorizontal = menu.hasClass('menu__horizontal'),
			isVertical = menu.hasClass('menu__vertical'),
			closeOnClickOutside = isHorizontal || menu.hasClass('js_menu__close-on-click-outside'),
			eventNamespace = 'multiLevelMenu' + menuIndex,
			resizeTimeout;

		if(isVertical && menu.hasClass('menu__is-fixed-height')) {
			var menuLis = [];
			menu.find('> ul').each(function() {
				menuLis.push($(this).html());
			});

			var menuUl = $('<ul/>', { html: menuLis });

			var newMenu = $('<ul/>', {
				html: $('<li/>', {
					class: 'menu__fixed-height-top-level',
					html : [$('<a class="js_menu__trigger-toggle-focus" href="javascript:void(0);">- Menu -</a>'), menuUl]
				})
			});
			menu.html(newMenu).addClass('js_menu-fixed-height-applied');
		}

		menu.data('event-namespace', eventNamespace);

		$(window).resize(function() {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(function() {
				resetMenu(menu);
			}, 350);
		});

		menu.on('reset', function() {
			resetMenu(menu);
		});

		if(closeOnClickOutside) {
			menu.on('focus', '> ul > li:not(.child-menu__visible) > a', function(e) {
				if($(e.target).is($(this))) {
					e.stopPropagation();
					resetMenu(menu);
				}
			});

			menu.find('> ul > li:has(> ul)').each(function() {
				$(this).find('a:last').blur(function(e) {
					setTimeout(function() {
						if($(':focus').closest($(this)).length === 0) {
							resetMenu(menu);
						}
					}, 25);
				});
			});
		}

		menu.find('li:has(> ul) > a').each(function() {
			var link = $(this),
				parent = link.closest('li'),
				child = parent.find('ul:first'),
				toggle, parents, otherChildren;

			if(child.length) {
				parent.addClass('menu__has-children');

				if(isVertical) setChildHeight(child);

				link.attr('aria-haspopup', 'true').attr('aria-expanded', 'false');

				toggle = $('<span/>', {
					class          : 'child-menu__toggle',
					tabindex       : '0',
					role           : 'button',
					'aria-expanded': 'false',
					html           : $('<span/>', {
						class: 'screen-reader-only',
						text : 'Toggle submenu for "' + link.text() + '"'
					})
				}).appendTo(link);

				link.click(function(e) {
					if($(e.target).is('.child-menu__toggle')) {
						e.preventDefault();
						e.stopPropagation();
					}
				});

				toggle.on('focus isExpanded', function(e) {
					e.stopPropagation();

					if(parent.hasClass('child-menu__visible')) {
						parent.find('.child-menu__visible').add(parent).removeClass('child-menu__visible').ariaExpandedFalse();

						if(isVertical) parent.find('ul').css('height', 0);

						parents = getParentsUntilMenu(toggle, menu);
						if(isVertical) resizeVerticalMenu(parents);
					} else {
						parent.addClass('child-menu__visible').find('> a, > a .child-menu__toggle').attr('aria-expanded', 'true');

						if(isHorizontal) {
							var wWidth = $(window).width(),
								eWidth = child.outerWidth(),
								eOffset = child.offset().left;

							if(wWidth < (eOffset + eWidth))
								parent.addClass('child-menu__left');
						}

						parents = getParentsUntilMenu(toggle, menu);
						if(isVertical) resizeVerticalMenu(parents);

						otherChildren = menu.find('.child-menu__visible').not(parents).find('ul');
						otherChildren.closest('.child-menu__visible').removeClass('child-menu__visible').ariaExpandedFalse();
						if(isVertical) otherChildren.css('height', 0);
					}

					if(closeOnClickOutside) {
						$(document).off('click.' + eventNamespace);
						$(document).on('click.' + eventNamespace, function(e) {
							if($(e.target).closest(menu).length === 0) {
								resetMenu(menu);
							}
						});
					}
				});

				if(parent.is('.expanded') && !parent.is('.child-menu__visible')) {
					toggle.trigger('isExpanded');
				}
			}
		});
	});
});
/* requires _functions.js */
(function($) {
    var body = $(document.body),
        transitionEndEvent = cph.whichTransitionEndEvent(),
        focusAfter;

    var onTransitionComplete = function(el, fallbackTime, callback) {
        // added :visible condition because transitions are not registered on hidden elements, and menu gets hidden by resize
        if(el.is(':visible') && transitionEndEvent && (typeof CSS === 'object') && CSS.supports('transform: translateX(0)')) {
            el.on(transitionEndEvent + '.offCanvasMenu', function(e) {
                if($(e.target).is(el)) {
                    e.stopPropagation();
                    callback.call();
                }
            });
        } else {
            setTimeout(function() {
                callback.call();
            }, fallbackTime);
        }
    };

    var closeMenu = function() {
        var menu = body.data('oc-menu'),
            overlay = body.data('oc-overlay');

        if(menu && menu.length) {
            body.addClass('push-menu__hiding').removeClass('push-menu__showing').data('oc-menu', '');
            onTransitionComplete(menu, 500, function() {
                body.removeClass('push-menu__hiding push-menu__showing--left push-menu__showing--right');
                menu.off('.offCanvasMenu');
                if(overlay && overlay.length) overlay.off('click');
                if(focusAfter && focusAfter.length) focusAfter.first().focus();

                var hash = window.location.hash.substr(1);
                if(hash && (hash === 'oc-left' || hash === 'oc-right')) {
                    if('referrer' in document) {
                        if(document.referrer === '' || document.referrer.indexOf(window.location.host) !== -1) {
                            window.history.back();
                        }
                    }
                }

                // triggering event to reset any multi-level menus contained in push menu
                menu.find('.menu__multi-level').trigger('reset');
            });
        }

        $(document).off('.offCanvasMenu');
        $(window).off('.offCanvasMenu');
    };

    var openMenu = function(menuSide) {
        var menu = $('#push-menu-' + menuSide),
            overlay = $('#push-menu-overlay-' + menuSide),
            resizeTimeout;

        body.removeClass('push-menu__showing push-menu__hiding push-menu__showing--left push-menu__showing--right');

        if(!menu.length) return;

        if(!overlay.length) {
            overlay = $('<div/>', {
                id   : 'push-menu-overlay-' + menuSide,
                class: 'push-menu__overlay push-menu__overlay--' + menuSide
            }).prependTo(body);
        }

        body.data('oc-menu', menu).data('oc-overlay', overlay);

        // quick timeout to assure css transition fires on overlay
        setTimeout(function() {
            body.addClass('push-menu__showing push-menu__showing--' + menuSide);
            onTransitionComplete(menu, 500, function() {
                menu.find('a, button, :input, [tabindex]').first().focus();
                overlay.one('click', function() {
                    closeMenu();
                });
            });
        }, 10);

        $(document).on('keydown.offCanvasMenu', function(e) {
            if(e.key.toLowerCase() === 'escape') {
                e.stopPropagation();
                closeMenu();
            }
        });

        $(window).on('orientationchange.offCanvasMenu', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                closeMenu();
            }, 350);
        });
    };

    var hashChangeSuppressed = false;

    $(document).on('click', '[data-oc-menu]', function(e) {
        e.preventDefault();
        var menuSide = $(this).data('oc-menu');
        if(menuSide === 'left' || menuSide === 'right') {
            focusAfter = $(this);
            hashChangeSuppressed = true;
            window.location.hash = '#oc-' + menuSide;
            openMenu(menuSide);
            setTimeout(function() {
                hashChangeSuppressed = false;
            }, 50);
        }
    });

    $(window).on('hashchange', function offCanvasMenu() {
        if(!hashChangeSuppressed) {
            if(window.location.hash === '#oc-left') {
                openMenu('left');
            } else if(window.location.hash === '#oc-right') {
                openMenu('right');
            } else if(body.has('.push-menu__showing--left, .push-menu__showing--right')) {
                closeMenu();
            }
        }
    });
})(jQuery);
jQuery(function($) {
    var menus = $('[data-settings-menu]:not(.tipped-loaded)');

    if(!menus.length) return false;

    var buildMenu = function(menuId, colorClass) {
        if(typeof window[menuId] !== 'undefined') {
            var loader = $('<div/>', {
                    class: 'loader-bar'
                }),
                menu = $('<ul/>', {'class': 'no-margin'}),
                wrap = $('<div/>', {
                    class: 'relative',
                    html : [loader, menu]
                });

            $.each(window[menuId], function(i, menuObj) {
                var el = '#' + menuId,
                    li = $('<li/>'),
                    a, form;

                if(menuObj.type === 'link') {
                    a = $('<a/>', {
                        class: 'settings-menu-button',
                        href : menuObj.url,
                        text : menuObj.label
                    }).click(function() {
                        Tipped.enable(el);
                        Tipped.hide(el);
                    });

                } else if(menuObj.type === 'form') {
                    a = $('<span/>', {
                        tabindex: 0,
                        class   : 'settings-menu-button',
                        text    : menuObj.label
                    }).click(function() {
                        Tipped.disable(el);
                        form.submit();
                    });

                    if(typeof menuObj.form !== 'undefined') {
                        form = menuObj.form;
                    } else {
                        form = cph.buildHiddenForm(menuObj.method, menuObj.url, menuObj.data);
                        form.data('confirm', menuObj.confirm);
                        form.data('success-callback', function() {
                            Tipped.enable(el);
                            Tipped.hide(el);
                        });
                        form.data('always-callback', function() {
                            Tipped.enable(el);
                            Tipped.hide(el);
                        });
                        form.data('confirm-cancel', function() {
                            Tipped.enable(el);
                            Tipped.hide(el);
                        });
                        form.appendTo('body');
                        menuObj.form = form;
                    }

                    form.data('use-loader', loader);
                }

                if(menuObj.atts) {
                    $.each(menuObj.atts, function(key, value) {
                        if(typeof value === 'object')
                            value = JSON.stringify(value);
                        a.attr(key, value);
                    });
                }

                a.addClass('btn expand no-border text-left');
                if(menuObj.icon !== 'undefined' && menuObj.icon) {
                    a.addClass('icon-left');
                    $('<i/>', {class: menuObj.icon}).prependTo(a);
                }

                li.html(a).appendTo(menu);
            });
            return wrap;
        }
    };

    cph.loadTipped(function() {
        $(document).on('click', '[data-settings-menu]', function(e) {
            e.preventDefault();

            var clicked = $(this),
                menuObj = clicked.data('settings-menu'),
                menuId = (typeof menuObj.id !== 'undefined') ? menuObj.id : null,
                menuTitle = (typeof menuObj.title !== 'undefined') ? menuObj.title : null,
                colorClass = (typeof menuObj.color !== 'undefined') ? menuObj.color : 'dark',
                zIndex = 3000;

            if(cph.litboxIsLoaded()) {
                if(Litbox.get(clicked).length) {
                    zIndex = Litbox.getZIndex(clicked) + 1;
                }
            }

            Tipped.remove(clicked);
            if(menuId) {
                Tipped.create(clicked, function() {
                    return {
                        title  : menuTitle,
                        content: buildMenu(menuId, colorClass)
                    };
                }, {
                    skin              : colorClass,
                    size              : 'huge',
                    position          : 'bottomright',
                    maxWidth          : 300,
                    showOn            : 'click',
                    hideOn            : false,
                    hideOthers        : true,
                    hideOnClickOutside: true,
                    padding           : false,
                    radius            : false,
                    zIndex            : zIndex,
                    onShow            : function(content, element) {
                        $(element).addClass('tipped-loaded settings-menu-visible').attr('aria-expanded', 'true');
                        $(content).find('.settings-menu-button:first').focus();

                        $(content).find('.settings-menu-button:last').keydown(function(e) {
                            if((e.which === 9 || e.key === 'Tab') && !e.shiftKey) {
                                e.preventDefault();
                                Tipped.hide(content);
                                $(element).focus();
                            }
                        });
                    },
                    afterHide         : function(content, element) {
                        $(element).removeClass('settings-menu-visible').attr('aria-expanded', 'false');
                    }
                }).show();
            }
        });
    });
});

/* requires _functions.js */
var cph = cph || {};
(function($) {
	cph.showProgressBar = function(el) {
		cph.updateProgressBar(el);
	};

	cph.updateProgressBar = function(el, pctComplete, text) {
		el = $(el);
		var progress = el.find('.progress-bar');
		if(!progress.length && el.is('.progress-bar'))
			progress = el;
		if(progress.length) {
			progress.slideDown(250, function() {
				if(pctComplete !== 'undefined') $(this).css('--progress-pct', pctComplete + '%');
				if(text !== 'undefined') $(this).attr('data-progress-text', text);
			});
		}
	};

	cph.hideProgressBar = function(el) {
		el = $(el);
		var progress = el.find('.progress-bar');
		if(!progress.length && el.is('.progress-bar'))
			progress = el;
		if(progress.length) progress.slideUp(90);
	};
})(jQuery);
/* requires _functions.js */
var cph = cph || {};
(function($) {
    cph.showResponse = function(element, type, message, close, callback) {
        var el = $(element).first(),
            responseClass = el.hasClass('text-response') ? 'text-response' : 'response',
            parent = el.parent(),
            isLitbox, isTipped;

        if(!el.length) return;

        var closestForm = el.closest('form');
        if(closestForm.length) parent = closestForm;

        if(cph.tippedIsLoaded())
            isTipped = !!(Tipped.get(element[0]).tooltips.length);

        isLitbox = cph.isInLitbox(el);

        el.off();

        if(message) {
            var resetPosition = function() {
                el.css({top: '', right: '', bottom: '', left: ''}).removeClass('fixed');
                parent.find('.spacer').remove();
                el.data('fixed-from', null);
            };

            var doAfterResponse = function() {
                callback.call(this);

                if(el.closest('#header, #page-wrap, #footer, .cph-lightbox').length) {
                    var litbox = el.closest('.cph-lightbox_inner'),
                        top, right, bottom, left;

                    var doPosition = function() {
                        var currentScroll, fixAbove, fixBelow;

                        resetPosition();

                        if(isLitbox && litbox.length) {

                            var lbOffsetTop = litbox.offset().top - $(window).scrollTop(),
                                lbOffsetBottom = lbOffsetTop + litbox.outerHeight();

                            currentScroll = el.offset().top;
                            fixAbove = litbox.offset().top + 16;
                            fixBelow = (litbox.offset().top - el.outerHeight()) + litbox.outerHeight() - 16;

                            if(currentScroll < fixAbove) {
                                el.data('fixed-from', 'above');

                                top = lbOffsetTop + 16;
                                bottom = 'auto';
                            } else if(currentScroll > fixBelow) {
                                el.data('fixed-from', 'below');

                                top = 'auto';
                                bottom = ($(window).height() - lbOffsetBottom) + 6;
                            }

                        } else {

                            var elOffsetTop = cph.getAdjustedTopOffset(el),
                                elOffsetBottom = elOffsetTop + el.outerHeight();

                            currentScroll = $(window).scrollTop();
                            fixAbove = currentScroll + 16;
                            fixBelow = (currentScroll + $(window).height()) - 16;

                            if(elOffsetTop < fixAbove) {
                                el.data('fixed-from', 'above');

                                top = cph.getFixedHeaderHeight() + 16;
                                bottom = 'auto';
                            } else if(elOffsetBottom > fixBelow) {
                                el.data('fixed-from', 'below');

                                top = 'auto';
                                bottom = 6;
                            }

                        }

                        if(el.data('fixed-from')) {
                            if(el.is('.show, .showing')) {
                                if(!el.find('.response-close').length) {
                                    $('<span class="response-close"/>').prependTo(el);
                                    el.on('closed', function() {
                                        resetPosition();
                                    });
                                }

                                if(!parent.find('.spacer').length) {
                                    var spacer = el.clone().attr('id', '');
                                    spacer.addClass('spacer show');
                                    spacer.css({
                                        transition: 'none',
                                        height    : 'auto',
                                        visibility: 'hidden',
                                        margin    : '',
                                        padding   : ''
                                    }).insertAfter(el);
                                }
                            }

                            left = parent.offset().left;
                            right = $(window).width() - parent.outerWidth() - left;

                            el.addClass('fixed').css({top: top, right: right, bottom: bottom, left: left});
                        }
                    };

                    doPosition();

                    $(window).add(litbox).off('scroll.responseEvent');
                    $(window).add(litbox).on('scroll.responseEvent', el, $.throttle(250, function(e) {
                        if(el.data('doing-scroll')) return;
                        el.data('doing-scroll', true);

                        var spacer = el.next('.spacer');
                        if(spacer.length && el.hasClass('fixed')) {
                            var undoFixed = false,
                                currentScroll, undoFixedAt,
                                parentTop, parentBottom, undoParentTop, undoParentBottom;

                            if(isLitbox && litbox.length) {
                                currentScroll = spacer.offset().top;
                                parentTop = parent.offset().top - litbox.offset().top;
                                parentBottom = parentTop + parent.outerHeight();

                                if(el.data('fixed-from') === 'above') {
                                    undoFixedAt = litbox.offset().top + 16;
                                    undoParentBottom = el.outerHeight() + 16;

                                    undoFixed = undoFixedAt < currentScroll;
                                    if(!undoFixed) undoFixed = parentBottom < undoParentBottom;
                                } else if(el.data('fixed-from') === 'below') {
                                    undoFixedAt = (litbox.offset().top + litbox.outerHeight()) - el.outerHeight() - 16;
                                    undoParentTop = litbox.outerHeight() - el.outerHeight() - 16;

                                    undoFixed = undoFixedAt > currentScroll;
                                    if(!undoFixed) undoFixed = parentTop > undoParentTop;
                                }

                            } else {
                                currentScroll = $(window).scrollTop();
                                parentTop = parent.offset().top;
                                parentBottom = parentTop + parent.outerHeight();

                                if(el.data('fixed-from') === 'above') {
                                    undoFixedAt = spacer.offset().top - 16;
                                    undoParentBottom = el.offset().top + el.outerHeight();

                                    undoFixed = undoFixedAt > currentScroll;
                                    if(!undoFixed) undoFixed = parentBottom < undoParentBottom;

                                } else if(el.data('fixed-from') === 'below') {
                                    undoFixedAt = (spacer.offset().top + spacer.outerHeight() + 16) - $(window).height();
                                    undoParentTop = el.offset().top;

                                    undoFixed = undoFixedAt < currentScroll;
                                    if(!undoFixed) undoFixed = parentTop > undoParentTop;
                                }
                            }

                            if(undoFixed) {
                                resetPosition();
                                $(window).add(litbox).off(e);
                            }
                        }

                        el.data('doing-scroll', false);
                    }));

                    $(window).off('resize.responseEvent');

                    $(window).on('resize.responseEvent', el, $.debounce(550, function() {
                        doPosition();
                    }));
                }
            };

            resetPosition();

            el.removeClass().addClass([responseClass, el.data('class'), type].join(' ')).html(message);

            if(close) {
                var closeButton = $('<span/>').addClass('response-close').prependTo(el);

                closeButton.click(function() {
                    clearTimeout(cph.closeResponseTimeout);
                    cph.hideResponse(el);
                });

                clearTimeout(cph.closeResponseTimeout);
                if(close !== true) {
                    cph.closeResponseTimeout = setTimeout(function() {
                        cph.hideResponse(el);
                    }, close);
                }
            }

            if(el.hasClass('faded')) {
                el.addClass('show');
                doAfterResponse();
            } else {
                el.addClass('showing');
                if(isTipped) {
                    el.show(0, function() {
                        el.addClass('show');
                        el.removeClass('showing');
                        Tipped.refresh(element[0]);
                        doAfterResponse();
                    });
                } else {
                    el.slideDown(250, function() {
                        el.addClass('show');
                        el.removeClass('showing');
                        doAfterResponse();
                    });
                }
            }
        }
    };

    cph.fadeResponse = function(el) {
        if(el.hasClass('show')) {
            el.off();
            el.addClass('faded');
        }
    };

    cph.hideResponse = function(el) {
        el.slideUp(180, function() {
            el.removeClass('show showing faded');
            el.trigger('closed');
        });
    };

    cph.hideAllResponses = function(leaveOpen) {
        leaveOpen = $(leaveOpen);
        $('.top-response, .response, .text-response').not(leaveOpen).filter('.show, .showing, .faded').each(function() {
            cph.hideResponse($(this));
        });
    };

    cph.topResponse = function(classes, message, timeout) {
        if(classes && message) {
            var responseContainer = $('#top-response'),
                responseBox, close;

            if(!responseContainer.length) {
                responseContainer = $('<div id="top-response" class="top-response"><\/div>').prependTo('body');
            }

            responseContainer.css({top: (cph.getFixedHeaderHeight() + 16)}); // _functions.js
            responseBox = $('<div/>').addClass('response').addClass(classes);
            close = $('<span/>').addClass('response-close').data('has-onclose', true);

            responseBox.html(close).append(message);

            responseBox.appendTo(responseContainer).addClass('showing').slideDown(180, function() {
                $(this).addClass('show');
                $(this).removeClass('showing');
            });

            close.click(function() {
                responseBox.slideUp(180, function() {
                    $(this).remove();
                });
            });

            $(window).off('.getTopResponses');

            $(window).on('resize.topResponse', responseContainer, $.throttle(350, function() {
                responseContainer.css({top: (cph.getFixedHeaderHeight() + 16)}); // _functions.js
            }));

            if(timeout) {
                setTimeout(function() {
                    responseBox.slideUp(180, function() {
                        $(this).remove();
                    });
                }, timeout);
            }
        }
    };

// FETCHES RESPONSES GENERATED BY PHP AND PROPERLY POSITIONS THEM SETS TIMERS
    cph.initPhpTopResponses = function() {
        var responseContainer = $('#top-response'),
            timedResponses, response, timeout;

        if(responseContainer.length) {
            responseContainer.css({top: (cph.getFixedHeaderHeight() + 16)}); // _functions.js

            $(window).on('resize.getTopResponses', responseContainer, $.throttle(350, function() {
                responseContainer.css({top: (cph.getFixedHeaderHeight() + 16)}); // _functions.js
            }));

            timedResponses = responseContainer.find('.response[data-hide]');
            response = [];
            timeout = [];

            if(timedResponses.length) {
                $.each(timedResponses, function(k) {
                    response[k] = $(this);
                    timeout[k] = response[k].data('hide');
                    setTimeout(function() {
                        response[k].slideUp(180, function() {
                            response[k].remove();
                        });
                    }, timeout[k]);
                });
            }
        }
    };
})(jQuery);

$(document).on('click', '.response-close', function(e) {
    e.preventDefault();
    var clicked = $(this),
        response = clicked.closest('.response, .text-response');
    if(!clicked.data('has-onclose') && response.length) {
        cph.hideResponse(response);
    }
});
var cph = cph || {};
(function($) {
	var scriptBeingLoaded = [],
		scriptIsLoaded = [];

	function async(u, c) {
		var d = document, t = 'script',
			o = d.createElement(t),
			s = d.getElementsByTagName(t)[0];
		o.src = '//' + u;
		if(c) { o.addEventListener('load', function(e) { c(null, e); }, false); }
		s.parentNode.insertBefore(o, s);
	}

	var checkIfScriptLoaded = function(name, src, callback, firstLoadCallback) {
		scriptBeingLoaded[name] = (scriptBeingLoaded[name] === 'undefined') ? null : scriptBeingLoaded[name];
		scriptIsLoaded[name] = (scriptIsLoaded[name] === 'undefined') ? null : scriptIsLoaded[name];

		if(scriptBeingLoaded[name] && !scriptIsLoaded[name]) {
			setTimeout(function() {
				checkIfScriptLoaded(name, src, callback);
			}, 250);
		} else {
			scriptBeingLoaded[name] = true;
			var methods = name.split('.'),
				functionName = window;

			for(var i in methods) functionName = functionName[methods[i]];

			if(typeof functionName === 'undefined') {
				if(!scriptIsLoaded[name]) {
					$.getScript(src).done(function(script, textStatus, jqxhr) {
						console.log(name + ' loaded');
						scriptIsLoaded[name] = true;
						if(jqxhr.status < 400) {
							if($.isFunction(firstLoadCallback)) {
								firstLoadCallback.call(this);
							}
							if($.isFunction(callback)) {
								callback.call(this);
							}
						}
					}).always(function() {
						scriptBeingLoaded[name] = false;
					});
					return;
				}
			}
			if($.isFunction(callback)) {
				callback.call(this);
			}
		}
	};

	var checkIfStyleLoaded = function(id, src) {
		if(!$('#' + id).length) {
			$('<link/>', {
				id  : id,
				rel : 'stylesheet',
				type: 'text/css',
				href: src
			}).appendTo('head');
		}
	};

	cph.loadJQueryUI = function(callback) {
		checkIfStyleLoaded('jquery-ui-css', 'https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/themes/smoothness/jquery-ui.min.css');
		checkIfScriptLoaded('jQuery.ui', 'https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js', callback);
	};

	cph.loadTipped = function(callback) {
		checkIfStyleLoaded('tipped-css', '/component/tipped/4.7.0/tipped.css');
		checkIfStyleLoaded('tipped-css-custom', '/css/tipped-custom.css');
		checkIfScriptLoaded('Tipped', '/component/tipped/4.7.0/tipped.min.js', callback, function() {
			Tipped.setStartingZIndex(10);
		});
	};

	cph.loadLitbox = function(callback) {
		checkIfScriptLoaded('Litbox', '/component/cph/litbox/4.0.0/litbox.min.js', callback, function() {
			Litbox.defaults.breakpoint = 768;
			Litbox.defaults.zIndex = 500;
			Litbox.defaults.width = '52em';
			Litbox.defaults.showClose = false;
			Litbox.defaults.closeOnClickOutside = false;
			Litbox.defaults.closeOnEscape = false;
			Litbox.defaults.on.open = 'checkDomInit';
			Litbox.defaults.on.close = 'checkDomInit';

			Litbox.setDefaultColors('#222222', '#FFFFFF', config.palette['primary']);
			Litbox.addDefaultColorClass('alert', config.palette['alert'], config.palette['alert_text']);
			Litbox.addDefaultColorClass('warning', config.palette['warning'], config.palette['warning_text']);
			Litbox.addDefaultColorClass('success', config.palette['success'], config.palette['success_text']);
			Litbox.addDefaultColorClass('info', config.palette['info'], config.palette['info_text']);
		});
	};

	cph.loadSortable = function(callback) {
		checkIfScriptLoaded('Sortable', 'https://cdnjs.cloudflare.com/ajax/libs/Sortable/1.10.2/Sortable.min.js', callback);
	};

	cph.loadSelectize = function(callback) {
		// http://selectize.github.io/selectize.js/
		checkIfStyleLoaded('selectize-css', 'https://cdnjs.cloudflare.com/ajax/libs/selectize.js/0.14.0/css/selectize.default.min.css');
		checkIfStyleLoaded('selectize-css-custom', '/css/selectize-custom.css');
		checkIfScriptLoaded('jQuery.fn.selectize', 'https://cdnjs.cloudflare.com/ajax/libs/selectize.js/0.14.0/js/standalone/selectize.min.js', callback);
	};

	cph.loadGrapesJs = function(callback) {
		checkIfStyleLoaded("grapesjs-css", "https://cdnjs.cloudflare.com/ajax/libs/grapesjs/0.16.41/css/grapes.min.css");
		checkIfScriptLoaded("grapesjs", "https://cdnjs.cloudflare.com/ajax/libs/grapesjs/0.16.41/grapes.min.js", callback);
	};

	cph.loadSwiper = function(callback) {
		checkIfStyleLoaded("swiper-css", "https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.4.5/css/swiper.min.css");
		checkIfScriptLoaded("Swiper", "https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.4.5/js/swiper.min.js", callback);
	};

	cph.loadTinyMCE = function(callback) {
		checkIfScriptLoaded('tinymce', 'https://cdnjs.cloudflare.com/ajax/libs/tinymce/5.10.7/tinymce.min.js', function() {
			checkIfScriptLoaded('jQuery.fn.tinymce', 'https://cdnjs.cloudflare.com/ajax/libs/tinymce/5.10.7/jquery.tinymce.min.js', callback);
		});
	};

	cph.loadDateRangePicker = function(callback) {
		// http://www.daterangepicker.com/
		checkIfStyleLoaded('daterangepicker-css', 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-daterangepicker/3.0.5/daterangepicker.min.css');
		checkIfScriptLoaded('moment', 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-daterangepicker/3.0.5/moment.min.js', function() {
			checkIfScriptLoaded('jQuery.fn.daterangepicker', 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-daterangepicker/3.0.5/daterangepicker.min.js', callback);
		});
	};

	cph.loadTableSorter = function(callback) {
		// if throwing jquery errors, check js files loaded by zebra_database for zebrajs. It loads a slim version of jquery which breaks tablesorter
		$(function() {
			// https://mottie.github.io/tablesorter/docs/index.html
			checkIfScriptLoaded('jQuery.fn.tablesorter', 'https://cdnjs.cloudflare.com/ajax/libs/jquery.tablesorter/2.31.3/js/jquery.tablesorter.combined.min.js', function() {
				checkIfScriptLoaded('jQuery.fn.tablesorterPager', 'https://cdnjs.cloudflare.com/ajax/libs/jquery.tablesorter/2.31.3/js/extras/jquery.tablesorter.pager.min.js', callback);
			});
			checkIfStyleLoaded('tablesorter-css-default', '/css/tablesorter-default.css');
		});
	};

	cph.loadSpectrum = function(callback) {
		checkIfScriptLoaded('jQuery.fn.spectrum', 'https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/spectrum.min.js', callback);
		checkIfStyleLoaded('spectrum-css-default', 'https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/spectrum.min.css');
	};

	cph.loadSlimImage = function(callback) {
		// https://pqina.nl/slim/#drag-drop-crop
		checkIfScriptLoaded('jQuery.fn.slim', '/component/slim-image/5.3.1/slim.jquery.min.js', callback);
		//checkIfScriptLoaded('Slim', '/component/slim-image/5.3.1/slim.global.min.js', callback);
		checkIfStyleLoaded('slim-css', '/component/slim-image/5.3.1/slim.min.css');
		checkIfStyleLoaded('slim-css-custom', '/css/slim-image-custom.css');
	};

	cph.loadAutoSize = function(callback) {
		checkIfScriptLoaded('autosize', 'https://cdnjs.cloudflare.com/ajax/libs/autosize.js/4.0.2/autosize.min.js', callback);
	};

	cph.loadImagesLoaded = function(callback) {
		checkIfScriptLoaded('imagesLoaded', 'https://cdnjs.cloudflare.com/ajax/libs/jquery.imagesloaded/4.1.4/imagesloaded.pkgd.min.js', callback);
	};

	cph.loadHighcharts = function(callback) {
		checkIfScriptLoaded('Highcharts', 'https://cdnjs.cloudflare.com/ajax/libs/highstock/6.0.3/highstock.js', callback);
	};

	cph.loadMask = function(callback) {
		checkIfScriptLoaded('jQuery.mask', 'https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.16/jquery.mask.min.js', callback);
	};
})(jQuery);